import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedbranchOffice, selectBranchOfficeState, setAction } from "../redux/slices/branchOfficeSlice"
import { BranchOffice } from "../types/slices/branchOfficeType"
import { BranchOfficeAPI } from "../apis/BranchOfficeAPI"

export const useBranchOfficeStore = () => {

    const dispatch = useDispatch()
    const { branchOffices, branchOfficeSelected, status, action } = useSelector(selectBranchOfficeState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getBranchOffice = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BranchOfficeAPI.getBranchOffice({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getBranchOfficeByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BranchOfficeAPI.getBranchOfficeByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getTypesBranches = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BranchOfficeAPI.getTypesBranches({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createBranchOffice = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BranchOfficeAPI.createBranchOffice({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editBranchOffice = async (idbranchoffice: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BranchOfficeAPI.editBranchOffice(idbranchoffice, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteBranchOffice = async (idbranchoffice: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await BranchOfficeAPI.deleteBranchOffice(idbranchoffice)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedBranchOffice = (branchoffice: BranchOffice) => {
        try {
            dispatch(onSetSelectedbranchOffice(branchoffice))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionBranchOffice = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        branchOffices,
        branchOfficeSelected,
        status,
        action,
        //actions
        getBranchOffice,
        getBranchOfficeByCompany,
        getTypesBranches,
        createBranchOffice,
        editBranchOffice,
        deleteBranchOffice,
        setSelectedBranchOffice,
        setActionBranchOffice,
    }
}